// Dependencies
import {
  TIPOS_UNIDAD_REQUEST,
  TIPOS_UNIDAD_OK,
  TIPOS_UNIDAD_ERROR,
} from "./types";
import { get } from "../../../../api/apiInstance";

const fetchTiposUnidad = () => async (dispatch) => {
  try {
    const response = await get("/tipos_unidad");
    const data = response["data"];
    dispatch({
      type: TIPOS_UNIDAD_OK,
      payload: { data: data["data"], qty: data["rowsAffected"] },
    });
    return Promise.resolve();
  } catch (error) {
    dispatch({ type: TIPOS_UNIDAD_ERROR, payload: error });
    return Promise.reject(error);
  }
};

export const getTiposUnidad = () => (dispatch) => {
  dispatch({ type: TIPOS_UNIDAD_REQUEST });
  dispatch(fetchTiposUnidad());
};
